import { PhaseTypeEnum } from '@vatos-pas/common';

export const PHASE_RELATIONSHIPS: Record<PhaseTypeEnum, PhaseTypeEnum | null> =
  {
    [PhaseTypeEnum.InteriorPaint]: PhaseTypeEnum.Prime,
    [PhaseTypeEnum.Trim2]: PhaseTypeEnum.Trim1,
    [PhaseTypeEnum.FinalPaint]: PhaseTypeEnum.InteriorPaint,

    [PhaseTypeEnum.Materials]: null,
    [PhaseTypeEnum.Garage]: null,
    [PhaseTypeEnum.Hanging]: null,
    [PhaseTypeEnum.Finishing]: null,
    [PhaseTypeEnum.Spraying]: null,
    [PhaseTypeEnum.Bump1]: null,
    [PhaseTypeEnum.Bump2]: null,
    [PhaseTypeEnum.Bump3]: null,
    [PhaseTypeEnum.Bump4]: null,
    [PhaseTypeEnum.Bump5]: null,
    [PhaseTypeEnum.Hang]: null,
    [PhaseTypeEnum.Finish]: null,
    [PhaseTypeEnum.Prime]: null,
    [PhaseTypeEnum.DrywallTouchUp1]: null,
    [PhaseTypeEnum.Trim1]: null,
    [PhaseTypeEnum.DrywallTouchUp2]: null,
    [PhaseTypeEnum.DrywallTouchUp3]: null,
    [PhaseTypeEnum.CMBluetape]: null,
    [PhaseTypeEnum.FinalBluetape]: null,
  };

export const AFFECTED_PHASES = [
  PhaseTypeEnum.InteriorPaint,
  PhaseTypeEnum.Trim2,
  PhaseTypeEnum.FinalPaint,
];

export const getPreviousPhaseType = (
  currentPhase: PhaseTypeEnum,
): PhaseTypeEnum | null => {
  return PHASE_RELATIONSHIPS[currentPhase];
};

export const isAffectedPhase = (phaseType: PhaseTypeEnum): boolean => {
  return AFFECTED_PHASES.includes(phaseType);
};

export const getPreviousPhaseContractor = (
  job: any,
  currentPhaseType: PhaseTypeEnum,
): any => {
  const previousPhaseType = getPreviousPhaseType(currentPhaseType);
  if (!previousPhaseType || !job?.jobPhases) {
    return null;
  }

  const previousPhase = job.jobPhases.find(
    (phase: any) => phase.phaseType === previousPhaseType,
  );

  if (!previousPhase || !previousPhase.contractorId) {
    return null;
  }

  return {
    id: previousPhase.contractorId,
    name:
      previousPhase.contractorName ||
      previousPhase.initialContractorName ||
      'Unknown Contractor',
  };
};

export const getPhaseDisplayName = (phaseType: PhaseTypeEnum): string => {
  const displayNames: Record<PhaseTypeEnum, string> = {
    [PhaseTypeEnum.InteriorPaint]: 'Interior Paint',
    [PhaseTypeEnum.Trim2]: 'Trim 2',
    [PhaseTypeEnum.FinalPaint]: 'Final Paint',
    [PhaseTypeEnum.Prime]: 'Prime',
    [PhaseTypeEnum.Trim1]: 'Trim 1',
    [PhaseTypeEnum.Materials]: 'Materials',
    [PhaseTypeEnum.Garage]: 'Garage',
    [PhaseTypeEnum.Hanging]: 'Hanging',
    [PhaseTypeEnum.Finishing]: 'Finishing',
    [PhaseTypeEnum.Spraying]: 'Spraying',
    [PhaseTypeEnum.Bump1]: 'Bump 1',
    [PhaseTypeEnum.Bump2]: 'Bump 2',
    [PhaseTypeEnum.Bump3]: 'Bump 3',
    [PhaseTypeEnum.Bump4]: 'Bump 4',
    [PhaseTypeEnum.Bump5]: 'Bump 5',
    [PhaseTypeEnum.Hang]: 'Hang',
    [PhaseTypeEnum.Finish]: 'Finish',
    [PhaseTypeEnum.DrywallTouchUp1]: 'Drywall Touch Up 1',
    [PhaseTypeEnum.DrywallTouchUp2]: 'Drywall Touch Up 2',
    [PhaseTypeEnum.DrywallTouchUp3]: 'Drywall Touch Up 3',
    [PhaseTypeEnum.CMBluetape]: 'CM Bluetape',
    [PhaseTypeEnum.FinalBluetape]: 'Final Bluetape',
  };
  return displayNames[phaseType] || 'Unknown Phase';
};
